export default __webpack_public_path__ + "static/media/06AW3JUL66.957f3834.jpg";